import React from 'react';
import { CheckboxProps } from 'types/ui';

interface ExtendedCheckboxProps extends CheckboxProps {
  compact?: boolean;
}

const Checkbox: React.FC<ExtendedCheckboxProps> = ({
  id,
  name,
  checked,
  onChange,
  label,
  disabled = false,
  className = '',
  compact = false,
}) => {
  // Optimized size for hospitality apps
  const size = compact ? 'w-3.5 h-3.5' : 'w-4 h-4';
  const textSize = compact ? 'text-xs' : 'text-sm';
  const spacing = compact ? 'ml-1.5' : 'ml-2';

  return (
    <label
      className={`flex items-center cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`${size} text-[#1E3A5F] bg-white border-2 border-gray-300 rounded focus:ring-[#1E3A5F] focus:ring-1 focus:ring-offset-0 transition-colors`}
      />
      <span className={`${spacing} ${textSize} text-text-secondary select-none`}>{label}</span>
    </label>
  );
};

export default Checkbox;
